var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingMOonCertexQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 490,
    height: 490,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h490v490H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 70)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 84)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 98)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 112)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 140)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 168)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 182)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 196)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 210)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 252)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 280)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 84 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 294)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 28 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 70 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 42 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 112 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 14 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 56 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 98 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 350)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 378)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 252 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 392)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 420 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 462 406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 238 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 336 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 406 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 126 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 168 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 280 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 378 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 294 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 308 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 392 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 448)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 140 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 154 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 182 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 196 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 210 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 224 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 266 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 322 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 350 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 364 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 434 462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.145 0 0 .145 448 462)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h70v70H15z",
    style: {
      fill: "none"
    },
    transform: "matrix(.98 0 0 .98 14 14)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 14H14v98h98V14H97.3zm0 83.3H28.7V28.7h68.6v68.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h70v70H15z",
    style: {
      fill: "none"
    },
    transform: "matrix(.98 0 0 .98 378 14)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M461.3 14H378v98h98V14h-14.7zm0 83.3h-68.6V28.7h68.6v68.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h70v70H15z",
    style: {
      fill: "none"
    },
    transform: "matrix(.98 0 0 .98 14 378)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 378H14v98h98v-98H97.3zm0 83.3H28.7v-68.6h68.6v68.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.42 0 0 .42 42 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.42 0 0 .42 406 42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v100H0z",
    style: {
      fill: "#000"
    },
    transform: "matrix(.42 0 0 .42 42 406)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingMOonCertexQr);
export default __webpack_public_path__ + "static/media/LoadingMOonCertexQR.a30d72b0eb8d82582f4fce2400ebb168.svg";
export { ForwardRef as ReactComponent };